import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';

@Component({
  selector: 'app-pharm-header',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './pharm-header.html',
  styleUrl: './pharm-header.css'
})


export class PharmHeader implements OnInit {
  currentTime: string = '';
  username: string = '';
  role: string = '';

  constructor(private router: Router) {}

  ngOnInit() {
    this.username = localStorage.getItem('name') || 'pharmacist';
    this.role = localStorage.getItem('role') || 'pharmacist';

    this.updateClock();
    setInterval(() => this.updateClock(), 1000);
  }

  updateClock() {
    const now = new Date();
    this.currentTime = now.toLocaleTimeString();
  }

  confirmLogout() {
    if (confirm('Logout now?')) {
      localStorage.removeItem('token');
      localStorage.removeItem('role');
      localStorage.removeItem('name');
      this.router.navigate(['/login']);
    }
  }
}
